export const segmentFeatureKey = 'segment';
